import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c08368d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white" }
const _hoisted_2 = { class: "row g-5 g-xxl-8" }
const _hoisted_3 = { class: "col-lg-8 p-5" }
const _hoisted_4 = { class: "pb-0" }
const _hoisted_5 = { class: "d-flex align-items-center mb-5" }
const _hoisted_6 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_7 = { class: "symbol symbol-45px me-5 rounded-circle" }
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-6 fw-bolder"
}
const _hoisted_10 = { class: "mb-5" }
const _hoisted_11 = {
  key: 0,
  class: "cursor-pointer"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "editing-btns" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-4" }, null, -1))
const _hoisted_17 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.commentsData, (comment, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "card mb-5 mb-xxl-8",
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_Avatar, {
                      firstName: comment.firstName,
                      lastName: comment.lastName
                    }, null, 8, ["firstName", "lastName"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("a", _hoisted_9, _toDisplayString(comment.firstName) + " " + _toDisplayString(comment.lastName), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.editing !== index)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_el_tooltip, {
                        class: "item",
                        effect: "dark",
                        content: "Click to Edit",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", {
                            class: "text-gray-800 fw-normal mb-5",
                            onClick: ($event: any) => (_ctx.enableEditing(index))
                          }, _toDisplayString(comment.desc), 9, _hoisted_12)
                        ]),
                        _: 2
                      }, 1024)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editing === index)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_el_input, {
                        type: "textarea",
                        autosize: "",
                        modelValue: comment.desc,
                        "onUpdate:modelValue": ($event: any) => ((comment.desc) = $event),
                        class: "input d-block mb-4 w-100 border-textarea"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", {
                          class: "svg-icon svg-icon-1 me-2",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveEditComment && _ctx.saveEditComment(...args)))
                        }, [
                          _createVNode(_component_inline_svg, { src: "svg/icons/check.svg" })
                        ]),
                        _createElementVNode("span", {
                          class: "svg-icon svg-icon-1",
                          onClick: ($event: any) => (_ctx.cancelEditing(index))
                        }, [
                          _createVNode(_component_inline_svg, { src: "svg/icons/cancel.svg" })
                        ], 8, _hoisted_15)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_16
            ])
          ]))
        }), 128)),
        _createElementVNode("div", null, [
          _createVNode(_component_el_input, {
            type: "textarea",
            modelValue: _ctx.tempValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tempValue) = $event)),
            class: "input d-block mb-7 textarea",
            autosize: { minRows: 4 },
            placeholder: "Please input",
            ref: "inputComment"
          }, null, 8, ["modelValue"]),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addComment && _ctx.addComment(...args))),
            class: "btn btn-sm btn-primary me-4",
            disabled: _ctx.isDisable
          }, " Add ", 8, _hoisted_17),
          _createElementVNode("span", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelAddComment && _ctx.cancelAddComment(...args))),
            class: "btn btn-sm btn-outline-primary"
          }, " Cancel ")
        ])
      ])
    ])
  ]))
}